module.exports = __webpack_public_path__ + "assets/img/79@3x.f79dece8.png";